<template lang="pug">
  .contact-icon
    el-tooltip(
      v-if="basicData.weibo_qr_code_url"
      placement="bottom"
      popper-class="supplier-info__qr-tooltip"
    )
      div(slot="content")
        img(
          v-if="weiboQrWidth",
          :src="basicData.weibo_qr_code_url"
          :class="{ widthFixed: weiboQrWidth/weiboQrHeight >= 1, heightFixed: weiboQrWidth/weiboQrHeight < 1 }",
        )
      i.iconfont.icon-weibo
    el-tooltip(
      v-if="basicData.wechat_qr_code_url"
      placement="bottom",
      popper-class="supplier-info__qr-tooltip"
    )
      div(slot="content")
        img(
          v-if="wechatQrWidth"
          :src="basicData.wechat_qr_code_url"
          :class="{ widthFixed: wechatQrWidth/wechatQrHeight >= 1, heightFixed: wechatQrWidth/wechatQrHeight < 1 }",
        )
      i.iconfont.icon-weixin
    a(
      v-if="basicData.website_url"
      :href="basicData.website_url" target="_blank"
    )
      i.iconfont.icon-wangzhanhui
</template>

<script>
export default {
  props: {
    basicData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      weiboQrWidth: null,
      weiboQrHeight: null,
      wechatQrWidth: null,
      wechatQrHeight: null
    }
  },
  mounted () {
    this.processImg()
  },
  methods: {
    processImg () {
      const self = this
      let weiboQr = new Image()
      weiboQr.src = this.basicData.weibo_qr_code_url
      weiboQr.addEventListener('load', function () {
        self.weiboQrHeight = this.naturalHeight
        self.weiboQrWidth = this.naturalWidth
      })
      let wechatQr = new Image()
      wechatQr.src = this.basicData.wechat_qr_code_url
      wechatQr.addEventListener('load', function () {
        self.wechatQrHeight = this.naturalHeight
        self.wechatQrWidth = this.naturalWidth
      })
    }
  }
}
</script>

<style lang="stylus">
  .contact-icon
    a
      text-decoration none
    .iconfont
      border 1px solid #cccccc
      font-size 18px
      padding 3px
      border-radius 50%
      color #bfbfbf
      &:nth-child(2)
        margin 0 16px
    .icon-wangzhanhui
      font-size 16px
      padding 4px
    .icon-wangzhanliang
      font-size 16px
      padding 4px
    .icon-weibo:hover
      color #D7242C
      border-color #D7242C
    .icon-weixin:hover
      color #21BF65
      border-color #21BF65
    .icon-wangzhanhui:hover
      color #398AFB
      border-color #398AFB
    .widthFixed
      width 100px
    .heightFixed
      width 100px

.supplier-info__qr-tooltip
  > div:nth-child(1)
    height 100px
    width 100px
    display flex
    justify-content center
    align-items center
    > .widthFixed
        width 100px
    > .heightFixed
        width 100px
</style>
